export const initialState = {
	devFeaturesEnabled: false
};

export default initialState;
